module.exports = __webpack_public_path__ + "static/media/faa.5a56febe.svg";